<template>
	<div class="text-centered">
		<div class="text-content">
			<template v-if="success">
				<h2>Bedankt!</h2>
				<p>
					We hebben je meting verstuurd. Je ontvangt een bevestigingsmail met daarin de unieke link van jou
					meting. Mocht je nog iets willen wijzigen in je meting kan dat via die link.
				</p>

				<div v-if="est.text">
					<br />
					<br />
					<h3>Tussenresultaat 2023</h3>

					<p>Op basis van jouw meetgegevens kunnen wij direct de ecosysteemtoestand van het water bepalen:</p>

					<br />

					<p v-html="est.text" />
				</div>

				<br />

				<p>
					Zodra je watermonster is geanalyseerd kunnen we de nutriëntenscore toevoegen en je het eindoordeel
					van jouw locatie geven. Dit zal in september gebeuren.
				</p>

				<div class="warning" v-if="waterboard">
					<p>
						Maak je je ernstige zorgen over de waterkwaliteit van dit water? Je kunt dan een melding maken
						bij jouw waterschap, via onderstaande link kom je op de website van jouw waterschap en kan je
						een melding doen.
					</p>

					<p>
						<a :href="waterboardLink" target="_blank"> Ga naar de website van mijn waterschap. </a>
					</p>
				</div>
			</template>

			<template v-else-if="sending">
				<h1>Verzenden</h1>
				<p>
					We zijn je meting aan het versturen. Hou dit scherm actief en we zullen zodra de verbinding het
					toelaat het formulier versturen.
				</p>

				<div class="wm-progress-container form-field">
					<div class="wm-progress" :style="{ transform: `translateX(${this.uploadProgress * 100}%)` }"></div>
					<div class="wm-progressbar"></div>
				</div>
			</template>

			<template v-else-if="error">
				<h1>Zwakke verbinding</h1>
				<p>
					Helaas is de verbinding te zwak om het formulier te versturen. Wij raden aan op naar een locatie te
					lopen waar de verbinding beter is.
				</p>
			</template>

			<template v-else>
				<h1>Einde!</h1>
				<p>Dit is het einde van de meting, klik op verzenden om je meting naar ons op te sturen.</p>

				<div class="form-field">
					<label for="">
						Opmerkingen
						<span class="subtitle">
							Heb je nog opmerkingen over je meting dan kun je die hieronder kwijt.
						</span>
					</label>
					<div class="textarea">
						<textarea
							name="remarks"
							maxlength="2000"
							placeholder="Opmerkingen (max 2000 karakters)"
							v-model="measurement.remarks"
							@keyup="countCharacter"
						>
						</textarea>
						<span>{{ remarkCount }} / 2000</span>
					</div>
					<span class="notice"
						>Bewaar het buisje met de watermonster in de koelkast en stuur de buisjes van je metingen zo
						snel mogelijk retour naar het NIOO-KNAW in de bijgeleverde envelop, het liefst binnen een
						week.</span
					>
				</div>
			</template>
		</div>

		<nav v-if="!success">
			<button type="button" @click.prevent="$emit('back')" class="btn-prev">Terug</button>
			<button type="button" @click.prevent="send" class="btn-next" :disabled="sending">Verzenden</button>
		</nav>
		<nav v-else>
			<button type="button" @click.prevent="$emit('restart')" class="btn-next">Doe nog een meting</button>
		</nav>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	name: 'FormStepSend',
	props: ['measurement', 'endpoint'],
	data() {
		return {
			uploadProgress: 0,
			sending: false,
			error: false,
			success: false,
			waterboard: null,
			est: null,
			remarkCount: 0,
		};
	},
	computed: {
		waterboardLink() {
			switch (this.waterboard) {
				case 'Waterschap Noorderzijlvest':
					return 'https://www.noorderzijlvest.nl/melding-doen';
				case 'Wetterskip Fryslân':
					return 'https://www.wetterskipfryslan.nl/melden-en-regelen/melding-en-klacht/overlast-of-schade-melden';
				case "Waterschap Hunze en Aa's":
					return 'https://formulieren.hunzeenaas.nl/form/melding-geen-spoed/';
				case 'Waterschap Drents Overijsselse Delta':
					return 'https://www.wdodelta.nl/calamiteit';
				case 'Waterschap Vechtstromen':
					return 'https://www.vechtstromen.nl/direct-regelen/calamiteiten/';
				case 'Waterschap Vallei en Veluwe':
					return 'https://www.vallei-veluwe.nl/toptaken/regelen-en-aanvragen/@29743/zie-raars-water/';
				case 'Waterschap Rijn en IJssel':
					return 'https://www.wrij.nl/melding-maken-over-water-onderhoud';
				case 'Hoogheemraadschap De Stichtse Rijnlanden':
					return 'https://www.hdsr.nl/regelen/melding-overlast/';
				case 'Waterschap Amstel, Gooi en Vecht':
					return 'https://www.agv.nl/aanvragen/waterschapsloket/waterhuishouding/ongewone-voorvallen-oppervlaktewater-als-gevolg-van-activiteiten/';
				case 'Hoogheemraadschap Hollands Noorderkwartier':
					return 'https://www.hhnk.nl/melding-over-water-en-dijken';
				case 'Hoogheemraadschap van Rijnland':
					return 'https://www.rijnland.net/loket/meldpunt/formulier-meldingen-en-incidenten/';
				case 'Hoogheemraadschap van Delfland':
					return 'https://www.hhdelfland.nl/regelen/incident-melden/vuil-water/';
				case 'Hoogheemraadschap van Schieland en de Krimpenerwaard':
					return 'https://www.schielandendekrimpenerwaard.nl/aanvragen-en-melden/melding-maken/';
				case 'Waterschap Rivierenland':
					return 'https://loket.waterschaprivierenland.nl/Loket/product/2c0ad3278ee23c06d3384a53b5a1f19b#:~:text=medewerker%20in%20contact.-,Meldingen%20over%20de%20vervuiling%20van%20het%20oppervlaktewater%20of%20ongewenste%20lozingen,(0344)%2064%2094%2010.&text=Om%20gebruik%20te%20maken%20van,calamiteiten%20melden%20bij%20Waterschap%20Rivierenland';
				case 'Waterschap Hollandse Delta':
					return 'https://www.wshd.nl/form/contact-algemeen/contactformulier-0';
				case 'Waterschap Scheldestromen':
					return 'https://scheldestromen.nl/melding-klacht';
				case 'Waterschap Brabantse Delta':
					return 'https://eloket.brabantsedelta.nl/nxt/f/135/login';
				case 'Waterschap De Dommel':
					return 'https://mijnwaterschap.dommel.nl/nxt/f/20975/login';
				case 'Waterschap Aa en Maas':
					return 'https://eloket.aaenmaas.nl/nxt/f/4003/login';
				case 'Waterschap Limburg':
					return 'https://www.waterschaplimburg.nl/formulieren/meldingenformulier/';
				case 'Waterschap Zuiderzeeland':
					return 'https://www.zuiderzeeland.nl/heeft-u-een-klacht';
			}
			return null;
		},
	},
	methods: {
		send() {
			console.log('send');
			// console.log(this.measurement);

			this.error = false;
			this.sending = true;

			this.uploadProgress = 0;

			axios
				.post(this.endpoint, this.measurement, {
					onUploadProgress: (progressEvent) => {
						this.uploadProgress = progressEvent.loaded / progressEvent.total;
					},
				})
				.then(({ data }) => {
					console.log(data);
					this.waterboard = data.waterboard;
					this.est = data.est;
					this.success = data.success;
					if (data.success) {
						this.$emit('reset');
					}
				})
				.catch((e) => {
					console.error(e);
					this.error = true;
				})
				.finally(() => {
					this.sending = false;
				});
		},
		countCharacter(event) {
			this.remarkCount = event.target.value.length;
		},
	},
};
</script>

<style scoped>
.wm-progress-container {
	position: relative;
	overflow: hidden;
	border-radius: 9px;
	height: 20px;
	width: 80%;
}

.wm-progressbar {
	height: 20px;
	background-color: #cdcfd5;
	width: 100%;
}

.wm-progress {
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	transform: translateX(0%);
	transition: transform 0.2s ease;
	background: #10303d;
	border-radius: 9px;
}

.form-field {
	margin-top: 32px;
	margin-bottom: 28px;
	text-align: left;
	width: 100%;
}

textarea {
	width: 100%;
	border: 1px solid RGB(218, 221, 226);
	padding: 22px 15px;
	border-radius: 7px;
	height: 100%;
}

.textarea {
	position: relative;
	height: 144px;
}

.textarea span {
	position: absolute;
	bottom: 6px;
	right: 6px;
	font-size: 1.2rem;
	font-weight: 300;
	font-style: italic;
	color: RGB(16, 48, 61);
	opacity: 0.5;
}

.warning {
	padding: 10px 16px 14px;
	margin: 18px;
	border-radius: 7px;
	border: solid 1px #d13d4d;
	background-color: rgba(209, 61, 77, 0.05);
}

.notice {
	display: block;
	margin-top: 16px;
	font-size: 1.2rem;
	line-height: 20px;
	opacity: 0.8;
	font-weight: 300;
}

h2 {
	font-size: 2rem;
}

h3 {
	text-align: center;
	font-size: 1.6rem;
	margin: 0;
	margin-bottom: 10px;
}
</style>
